import { call, put, takeLatest } from "redux-saga/effects";
import { SPSELECTS } from "../../InterfacesTypes/enums";
import { spGet } from "../../utils/SharepointAPI";
import { getEnvironment } from "../../utils/utils";
import {
  fetchFailure,
  fetchResourceLinks,
  fetchStart,
  fetchSuccess,
} from "../Reducers/ResourceLinksReducer";
import type { IResourceLinks } from "../../InterfacesTypes/interfaces";
import type { SagaIterator } from "redux-saga";

const env = getEnvironment();

function* getResourceLinksWorker(): SagaIterator {
  try {
    yield put(fetchStart());

    const resourceLinksListUrl = `${env.listapi}/GetByTitle('ResourceLinks')/Items?$top=5000&$select=${SPSELECTS.RESOURCELINKS}`;

    const res: any = yield call(spGet, resourceLinksListUrl);
    const data: IResourceLinks[] = Array.isArray(res)
      ? res
      : res?.value ?? res?.d?.results ?? [];

    yield put(fetchSuccess(data));
  } catch (err: any) {
    console.error("getResourceWorker error:", err);
    yield put(
      fetchFailure(
        err?.response?.data?.error?.message || err?.message || "Något gick fel"
      )
    );
  }
}

export function* resourceLinksSaga(): SagaIterator {
  yield takeLatest(fetchResourceLinks.type, getResourceLinksWorker);
}
